import { Component } from 'react'
import truncate from 'lodash.truncate'

import * as h from 'h'

import ResultsIndicator from 'components/ResultsIndicator'
import Dates from './Dates'

import { smartDate } from 'utils'

import styles from './styles-story-line.scss'
import indexStyles from './styles.scss'

class Tag extends Component {
  render () {
    const { name } = this.props
    // const { onClick } = this.props // add tag

    return h.div(h.ca('label'),
      h.span(null, name))
  }
}

class Story extends Component {
  // ------------------------------------------------------------------------
  // Helpers
  // ------------------------------------------------------------------------

  get hasImage () {
    const { story: { image } } = this.props
    return !!((image && image.tile))
  }

  // ------------------------------------------------------------------------
  // Data
  // ------------------------------------------------------------------------

  get content () {
    let { story: { content } } = this.props

    // content editors requested horizontal rules to be used as a preview
    // break point.
    content = content.split('<hr />', 1)[0]

    return truncate(content, {
      length: 600,
      separator: /,? +/
    })
  }

  get sharableLink () {
    const { story: { type, id, title } } = this.props
    // Adding optional name to the end just for prettyness. The ID is the
    // important part. Encoding name since some have /'s in them.
    const urlencodedTitle = encodeURIComponent(title)
    return `/${type}/${id}/${urlencodedTitle}`
  }

  // ------------------------------------------------------------------------
  // Sub-components
  // ------------------------------------------------------------------------

  get tagsElementMaybe () {
    const { story: { tags } } = this.props

    return tags.length === 0 ? null : (
      h.div(h.ca(styles.wrapper),
        tags.map(tag => h.h(Tag, {
          key: tag,
          name: tag,
          onClick: this.props.addTag
        }))))
  }

  get imageColMaybe () {
    const { story } = this.props

    return !this.hasImage ? null : (
      h.div(h.ca(styles.imageCol),
        h.l({ to: this.sharableLink },
          h.img({ src: story.image.tile, alt: story.title, name: '' })))
      )
  }

  get postedOnMaybe () {
    const { story: { createdAt } } = this.props

    const postedDate = smartDate(createdAt, true)

    return !postedDate ? null : (
      h.div(h.ca(styles.postedOn), `Posted ${postedDate}`)
    )
  }

  get publishedOnMaybe () {
    const { story: { publishDate } } = this.props

    const publishedDate = smartDate(publishDate)

    return !publishedDate ? null : (
      h.div(h.ca(styles.postedOn), `Published ${publishedDate}`)
    )
  }

  get whenMaybe () {
    const { story } = this.props

    return h.h(Dates, { story })
  }

  // ------------------------------------------------------------------------
  // Render
  // ------------------------------------------------------------------------

  render () {
    const { story } = this.props

    const { id, type, title, location } = story

    return h.div({ key: id, ...h.ca(styles.storyLine) },
      type === 'news' ? this.publishedOnMaybe : this.postedOnMaybe,
      h.div(h.ca(styles.inner),
        this.imageColMaybe,
        h.div(null,
          h.h3(h.ca(styles.title),
            h.l({ to: this.sharableLink }, title)),
          this.whenMaybe,
          location ? h.p(h.ca('small'), location) : null,
          this.tagsElementMaybe,
          h.raw({ content: this.content }),
          h.l({ to: this.sharableLink, ...h.ca(indexStyles.btn) },
            `View ${type === 'news' ? 'Story' : 'Event Details'}`))))
  }
}

export default class Stories extends Component {
  render () {
    const { stories, addTag, isRequesting } = this.props

    return h.div(null,
      h.div(null,
        stories.map(story =>
          h.h(Story, {
            key: story.id,
            addTag,
            story
          }))),
      h.h(ResultsIndicator, {
        showProgress: isRequesting,
        hasResults: stories.length > 0
      }))
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/containers/NewsEvents/Stories.js